var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Box',{class:_vm.classes,attrs:{"data":_vm.data,"data-final":_vm.isFinal,"data-exhausted":_vm.isExhausted},on:{"click":_vm.onClick,"touchstart":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }